import "./carrier-error-modal.css";

import { DialogActionsBar } from "@tql/ui-components-react/kendo/dialogs";
import { Button } from "@tql/ui-components-react/tql/buttons";
import { useNavigate } from "react-router";

import { routes } from "~/app/routes/web-routes.ts";
import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";
import { useDeploymentType } from "~/shared/hooks/use-deployment-type.ts";

type ModalProps = {
	showModal: boolean;
	onDismiss: () => void;
	resetForm?: () => void;
};

export const CarrierErrorModal = ({
	showModal,
	onDismiss,
	resetForm,
}: ModalProps) => {
	const { isInternal } = useDeploymentType();
	const navigate = useNavigate();

	if (!showModal) return null;

	const handleNewQuote = () => {
		resetForm?.();
		onDismiss();
		navigate(routes.quoteDetails);
	};

	return (
		<TraxModal
			className={"carrier-error-modal"}
			onClose={onDismiss}
			title={isInternal ? undefined : "Under Review"}
			width={"25%"}
		>
			<p>
				{isInternal
					? "Your quote returned no automated rates. Please rate manually."
					: "Your quote request is being evaluated by TQL's LTL team. You will be contacted shortly once a quote is available."}
			</p>
			<DialogActionsBar layout={"end"}>
				{!isInternal && <Button onClick={handleNewQuote}>New Quote</Button>}
				{isInternal ? <Button onClick={onDismiss}>Close</Button> : null}
			</DialogActionsBar>
		</TraxModal>
	);
};
